import {useUser} from "../../../context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultView from "../../../components/ResultView";
import CheckCSName from "../CheckCSName";

export function G6({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const renderTable = (row, settings) => {
    const getColor = (cs_name, col_idx) => {

        if(row?.adjusted?.find(z => z?.cross_section === cs_name && z?.col_index === col_idx))
            return '#00B050'

        if(row?.tnm_profiles?.includes(col_idx)) {
            return '#00B0F0'
        }

        return ''
    }

    return (
        <>
            <ResultText>
                The processed (interpolated, choking, and crossing adjusted) library model WSEL table is noted below. The interpolated WSELs are highlighted with blue background, and the adjusted WSELs are highlighted with green background.
                <EmptyLine />

                Target Not Met Profile Adjustment = {settings?.defaults?.tnm_adjustment}
                <EmptyLine height={1}/>
                Crossing Profile Adjustment = {settings?.defaults?.crossing_adjustment}
                <EmptyLine height={1}/>
                Choking Cross Section Adjustment = {settings?.defaults?.choking_adjustment}
            </ResultText>
            <EmptyLine/>
            <div style={{width: '99%', overflowX: 'auto'}}>
                <ResultTable style={{width: HecRasHelper.getWidth(12) + (HecRasHelper.getWidth(8) * row?.columns?.length)}}  data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>River Station</ResultHeaderCell>
                            {
                                row?.columns?.map((c, idx) => (
                                    <ResultHeaderCell style={{
                                        textAlign: 'end',
                                        width: HecRasHelper.getWidth(8),
                                        backgroundColor: row?.tnm_profiles?.includes(idx) ? '#00B0F0' : '#f0f2f5',
                                    }}>
                                        {c}
                                    </ResultHeaderCell>
                                ))
                            }
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            row?.data?.map(r => {
                                return (
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'start', fontWeight: 'normal'}}>
                                            <CheckCSName csName={r?.cross_section} />
                                        </ResultHeaderCell>
                                        {
                                            r?.data.map((x, idx) => (
                                                <ResultBodyCell style={{
                                                    textAlign: 'right',
                                                    backgroundColor: getColor(r?.cross_section, idx),
                                                    width: HecRasHelper.getWidth(8)
                                                }}>{x}</ResultBodyCell>
                                            ))
                                        }
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </div>
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.LB04.error_id: {
            return (
                <>
                    {
                        row?.count > 0 && (
                            <ResultText>
                                There are {row?.count} WSEL values identified and adjusted to prevent choking cross sections.
                            </ResultText>
                        )
                    }
                    {
                        row?.count === 0 && (
                            <ResultText>
                                There are no choking cross sections identified, therefore no adjustment is needed.
                            </ResultText>
                        )
                    }
                </>
            )
        }
        case MessageCodes.Internal.LB05.error_id: {
            return (
                <>
                    {
                        row?.count > 0 && (
                            <ResultText>
                                There are {row?.count} WSEL values identified and adjusted to prevent crossing profiles.
                            </ResultText>
                        )
                    }
                    {
                        row?.count === 0 && (
                            <ResultText>
                                There are no crossing profiles identified, therefore no adjustment is needed.
                            </ResultText>
                        )
                    }
                </>
            )
        }
        case MessageCodes.Internal.LB06.error_id: {
            return renderTable(row, settings)
        }
        case MessageCodes.Internal.LB09.error_id: {
            return renderTable(row, settings)
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }


}